import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/tablet/49_leaves/49_leaves"
 * Contains 1 texture(s)
 */
export class Tablet49LeavesAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/tablet/49_leaves/49_leaves';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '49_leaves.jpg'
    ] as const;
}
